import React, { Component } from 'react';
import { Card } from 'material-ui/Card';
import { DateTime } from 'luxon';
import get from 'lodash.get';
import ProjectStats from './ProjectStats';
import ProjectDateFilter from './ProjectDateFilter';
import ProjectExport from './ProjectExport';

class StatsScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      updatedAtAfter: null,
      updatedAtBefore: null,
      ids: []
    };
  }

  componentDidMount() {
    this.getStateDataFromRoute();
  }

  getStateDataFromRoute() {
    const ids = get(this.props, 'match.params.ids', '')
      .split(',')
      .filter(e => e);
    const idsAsString = JSON.stringify(ids);
    if (idsAsString !== this.state.idsAsString) {
      this.setState({
        ids,
        idsAsString
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.getStateDataFromRoute();
  }

  _onAfterDateChange = (e, date) => {
    this.setState({
      updatedAtAfter: date
    });
  };

  _onBeforeDateChange = (e, date) => {
    this.setState({
      updatedAtBefore:
        date &&
        DateTime.fromJSDate(date)
          .endOf('day')
          .toJSDate()
    });
  };

  render() {
    return (
      <Card>
        <div style={{ padding: 20 }}>
          <h1 className="title">Stats</h1>
          {!this.state.ids.length && (
            <div>
              <p>No data</p>
            </div>
          )}
          {this.state.ids.length && (
            <ProjectStats
              record={{ id: this.state.ids }}
              groupped
              updatedAtAfter={this.state.updatedAtAfter}
              updatedAtBefore={this.state.updatedAtBefore}
            >
              <div>
                <ProjectDateFilter
                  onAfterDateChange={this._onAfterDateChange}
                  onBeforeDateChange={this._onBeforeDateChange}
                  updatedAtAfter={this.state.updatedAtAfter}
                  updatedAtBefore={this.state.updatedAtBefore}
                />
                <ProjectExport
                  multiple
                  record={{ id: this.state.ids }}
                  updatedAtAfter={this.state.updatedAtAfter}
                  updatedAtBefore={this.state.updatedAtBefore}
                />
              </div>
            </ProjectStats>
          )}
        </div>
      </Card>
    );
  }
}

export default StatsScreen;



// WEBPACK FOOTER //
// ./src/components/StatsScreen.js